<!-- eslint-disable -->
<template>
  <CommonPages id="privacy" :class="['privacy-page']" :titlePrefix="'Privacy Policy'"
    :metaDescription="domainConfig?.['meta']?.des || 'Privacy Policy and information about how we use your data'">
    <div class="privacy-full">
      <div class="privacy-full__container">
        <div class="privacy-full__content">
          <h1 class="privacy-full__title">Privacy Policy</h1>
          <div class="privacy-full__body">
            <div class="privacy-section">
              <p class="privacy-section__text">
                Welcome to {{ domainConfig?.siteName }}. We value your privacy and are committed to
                protecting your personal information. This
                privacy policy outlines how we collect, use, and safeguard your data.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">1. Information Collection</h2>
              <p class="privacy-section__text">
                We do not collect or store users' personal data. We use Firebase to collect general
                behavioral data to enhance website
                functionality. This data does not include any personally identifiable information.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">2. Use of Information</h2>
              <p class="privacy-section__text">
                <strong>Behavioral Data:</strong> We use the collected data to analyze how users
                interact with our website to optimize user experience
                and performance.
              </p>
              <p class="privacy-section__text">
                <strong>Service Improvement:</strong> This data helps us identify opportunities for
                website enhancements.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">3. Cookie Policy</h2>
              <p class="privacy-section__text">
                We do not use cookies to collect user information. Our website is designed to ensure
                that user privacy is not
                compromised.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">4. Data Security</h2>
              <p class="privacy-section__text">
                We take reasonable measures to protect the security of the data collected and
                prevent unauthorized access and use.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">5. Third-Party Services</h2>
              <p class="privacy-section__text">
                The Firebase services we use may collect and process data to provide analytics
                services. Please refer to Firebase's
                privacy policy for more information.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">6. Changes to This Policy</h2>
              <p class="privacy-section__text">
                We may update this privacy policy from time to time. Any changes will be posted on
                this page and will take effect
                immediately. Please review it regularly to stay informed.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">7. Contact Us</h2>
              <p class="privacy-section__text">
                If you have any questions about this privacy policy or need further information,
                please contact us at {{ domainConfig?.IAMEMAIL }}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'Privacy',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.privacy-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	margin: 0 0 rem(88);

	&__container {
		width: 100%;
		position: relative;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(88) rem(120);
		position: relative;
		z-index: 1;
	}

	&__title {
		color: #1a4048;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
	}
}

.privacy-section {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	align-self: stretch;

	&__title {
		color: #1a4048;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__subtitle {
		color: #1a4048;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: rem(8) 0;
	}

	&__text {
		color: #1a4048;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		margin: rem(8) 0;
	}

	&__link {
		color: #1a4048;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__list,
	&__numbered-list {
		color: #1a4048;
		padding-left: rem(24);
		margin: rem(8) 0;

		li {
			margin-bottom: rem(10);
			line-height: rem(28);
			font-size: rem(16);

			strong {
				color: #1a4048;
				font-weight: 500;
				display: block;
				margin-bottom: rem(4);
			}
		}
	}

	&__numbered-list {
		counter-reset: section;
		list-style-type: none;
		padding-left: 0;

		> li {
			margin-bottom: rem(24);
			padding-left: rem(24);
			position: relative;

			&:before {
				counter-increment: section;
				content: counter(section) '.';
				position: absolute;
				left: 0;
				color: #1a4048;
				font-weight: 500;
			}
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.privacy-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.privacy-full {
		&__content {
			width: 100%;
			padding: rem(40) rem(16);
		}

		&__title {
			font-size: rem(20);
			line-height: rem(20);
		}
	}

	.privacy-section {
		&__title {
			font-size: rem(16);
			line-height: rem(20);
		}

		&__subtitle {
			font-size: rem(14);
			line-height: rem(20);
		}

		&__text {
			font-size: rem(14);
			line-height: rem(24);
		}

		&__list,
		&__numbered-list {
			li {
				font-size: rem(14);
				line-height: rem(24);
			}
		}
	}
}
</style> 